<script>
import sideItems from './sidebar-items';
import SidebarMenuItem from './SidebarItem.vue';

export default {
    name: 'SidebarComponent',

    components: {
        SidebarMenuItem
    },

    data() {

        return {
            sideItems,
            showSidebar: false,
        };
    },
}
</script>
<template>
    <div id="side-bar" class="flex bg-gray-900 min-h-screen overflow-y-auto 
        shadow-lg fixed sm:top-auto relative z-0"  
        :class="showSidebar ? `w-56` : `w-10`" 
        @mouseenter="showSidebar=true" 
        @mouseleave="showSidebar=false" >
        <div class="md:mt-12 md:fixed md:left-0 md:top-0 sm:relative content-center 
            md:content-start text-left h-full overflow-auto" :class="showSidebar ? `w-56` : `w-10`">
            <ul class="list-reset flex flex-col py-0 md:py-1 mb-16 px-1 md:px-1 text-left">
                <SidebarMenuItem 
                    v-for="(sideItem, index) in sideItems" :key="index" 
                    :item="sideItem" :showFull="showSidebar"/>
            </ul>
        </div>
    </div>
</template>
